(function (root) {
  'use strict';
  const APPROVED_THEME = String(root.Shopify?.theme?.id);
  const LIVE_STOCK_ENABLED = false;
  const WILLOW = 'o_8da268a53f6942029c83bec1';
  const TAIWAN_LOCATIONS = Object.freeze(['61570515046', '61570449510']);
  const RULES = Object.freeze([
    { id: 349277, key: 'willow', vendors: ['JDMuscle', 'Racing Art'], locations: ['71168852070'], min: 1, max: 20000 },
    { id: 349278, key: 'distribution', locations: ['61767942246', '61767975014'], min: 1, max: 20000 },
    { id: 349280, key: 'out_of_stock', excludes: ['Dmann Tuning', 'Route'], min: -100000, max: 0 },
    { id: 349284, key: 'dmann', vendors: ['Dmann Tuning'] },
    { id: 349285, key: 'idoing', vendors: ['Idoing'] },
    { id: 349286, key: 'seibon', vendors: ['Seibon'], tags: ['Hoods', 'Fenders', 'Bumpers', 'Spoilers and Wings', 'Front Lips', 'Trunks'], min: 1, max: 1000 },
    { id: 349287, key: 'taiwan', locations: TAIWAN_LOCATIONS, min: 1, max: 20000 },
    { id: 349315, key: 'tomei', vendors: ['Tomei'], locations: ['68164386918'], min: 1, max: 1000 },
    { id: 366936, key: 'jdc', vendors: ['JD Customs U.S.A'] },
    { id: 380142, key: 'mfg', vendors: ['PRL Motorsports', 'GrimmSpeed', 'STM Tuned', 'STM Tuned Inc.', 'EOS', 'Extreme Turbo Systems', 'MAPerformance', 'IAG Performance'], min: 1, max: 1000 }
  ]);
  const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
  // No current provider supplies this proof. Keep Taiwan hidden until a verified
  // selected-variant fulfillment decision is available; stock/collection alone is insufficient.
  function verifiedTaiwanSource(stock, selected, requested, now) {
    const source = stock.reason === 'validated' ? stock.fulfillmentSource : null;
    return object(source) && source.verified === true && source.variantId === selected
      && TAIWAN_LOCATIONS.includes(source.locationId) && source.quantity === requested
      && Number.isSafeInteger(source.observedAt) && Number.isSafeInteger(source.expiresAt)
      && source.observedAt <= now && now < source.expiresAt
      && source.expiresAt <= source.observedAt + 300000 ? source : null;
  }
  function hasCompleteEstimate(result) {
    return !result.keys.some(key => ['confirmation', 'out_of_stock', 'quantity_confirmation'].includes(key))
      && result.keys.some(key => ['taiwan', 'idoing', 'seibon'].includes(key));
  }
  function merchantEstimateIsApplicable(marker, selected, now) {
    if (!object(marker) || marker.variantId !== selected || !/^[1-9]\d*$/.test(selected) || !Number.isFinite(now)) return false;
    if (typeof marker.date === 'string' && marker.date) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(marker.date)) return false;
      const midnight = Date.parse(marker.date + 'T00:00:00Z');
      return Number.isFinite(midnight) && new Date(midnight).toISOString().slice(0, 10) === marker.date
        && now <= midnight + 86400000 - 1;
    }
    return typeof marker.days === 'string' && /^\d+$/.test(marker.days)
      && Number.isSafeInteger(Number(marker.days));
  }
  function coloredTitaniumSelected(payload, selected) {
    const variant = payload?.variant;
    if (!object(variant) || variant.id !== selected || typeof variant.title !== 'string' || !Array.isArray(variant.options)) return false;
    const material = String(payload.product?.title || '') + ' ' + variant.title;
    if (!/\btitanium\b/i.test(material) || /\btitanium\s+(?:look|style|colou?r|finish)\b/i.test(material)) return false;
    const selectedValues = [...variant.options.filter(value => typeof value === 'string'), ...variant.title.split('/')]
      .map(value => value.trim().toLowerCase());
    if (selectedValues.some(value => /\b(bare|raw|plain|natural|uncolou?red|unanodized|un-anodized|brushed|polished)\b/.test(value))) return false;
    const finishes = new Set(['burnt', 'rainbow', 'bronze', 'blue', 'purple', 'gold', 'green', 'red', 'pink', 'black', 'freaktanium', 'blurple', 'sky blue', 'light purple', 'aqua', 'teal', 'custom color', 'colored titanium', 'coloured titanium']);
    return selectedValues.some(value => finishes.has(value) || /^(?:anodized|anodised) (?:blue|purple|gold|bronze|green|red|pink|black)(?: titanium)?$/.test(value)
      || /^(?:blue|purple|gold|bronze|green|red|pink|black|burnt|rainbow) titanium$/.test(value));
  }
  function evaluatePolicy(payload, selected, requested, now, stock = {}) {
    const fallback = { rules: [], keys: ['confirmation'], nextExpiry: null };
    if (!object(payload) || payload.variantId !== selected || !/^[1-9]\d*$/.test(selected)
      || !object(payload.product) || typeof payload.product.vendor !== 'string'
      || !Array.isArray(payload.product.tags) || !Array.isArray(payload.product.collections)
      || !Number.isFinite(now) || !Number.isSafeInteger(requested) || requested < 1) return fallback;
    const product = payload.product;
    const observed = Number.isSafeInteger(payload.renderedAt) ? payload.renderedAt : Date.parse(payload.renderedAt);
    const inventoryFresh = Number.isFinite(observed) && observed <= now && now < observed + 300000;
    const aggregate = inventoryFresh && payload.inventoryTracked === true && Number.isSafeInteger(payload.inventoryQuantity)
      ? payload.inventoryQuantity : null;
    const rows = stock.reason === 'validated' && Array.isArray(stock.warehouses) ? stock.warehouses : [];
    const willow = rows.find(row => row.originId === WILLOW && row.expiresAt > now
      && Number.isSafeInteger(row.availableQuantity) && row.availableQuantity >= requested);
    if (willow) return { rules: [{ id: 349277, key: 'willow', stockVerified: true, precedence: 'verified_physical_willow' }], keys: ['willow'], nextExpiry: willow.expiresAt };
    const taiwan = verifiedTaiwanSource(stock, selected, requested, now);
    if (taiwan) return { rules: [{ id: 349287, key: 'taiwan', stockVerified: true, directShipOriginVerified: true }], keys: ['taiwan'], nextExpiry: taiwan.expiresAt };
    const matches = [];
    for (const rule of RULES) {
      if (rule.key === 'taiwan') continue;
      if (rule.vendors && !rule.vendors.includes(product.vendor)) continue;
      if (rule.excludes?.includes(product.vendor)) continue;
      if (rule.tags && !rule.tags.some(tag => product.tags.includes(tag))) continue;
      if (rule.collection && !product.collections.map(String).includes(rule.collection)) continue;
      if (rule.key === 'jdc' && !coloredTitaniumSelected(payload, selected)) continue;
      if (['mfg', 'tomei'].includes(rule.key) && (aggregate === null || aggregate < requested || aggregate > rule.max)) continue;
      let count = aggregate, expires = inventoryFresh ? observed + 300000 : null;
      if (rule.locations) {
        const row = rule.locations.length === 1 && rule.locations[0] === '71168852070'
          ? rows.find(item => item.originId === WILLOW && item.expiresAt > now && Number.isSafeInteger(item.availableQuantity)) : null;
        count = row ? row.availableQuantity : null;
        expires = row?.expiresAt ?? null;
      }
      if (rule.min !== undefined && count !== null && (count < rule.min || count > rule.max)) continue;
      if (rule.min > 0 && count !== null && count < requested) continue;
      if (rule.key === 'out_of_stock' && count === null) continue;
      matches.push({ id: rule.id, key: rule.key, stockVerified: rule.min === undefined ? null : rule.key === 'mfg' ? false : count !== null,
        directShipOriginVerified: ['mfg', 'tomei'].includes(rule.key) ? false : undefined, expires });
    }
    const specific = matches.filter(rule => !['distribution', 'out_of_stock'].includes(rule.key));
    const out = matches.find(rule => rule.key === 'out_of_stock');
    let chosen = specific.length ? specific : out ? [out] : matches.filter(rule => rule.key === 'distribution');
    if (out && specific.length) chosen = [...chosen, out];
    const keys = chosen.map(rule => rule.key);
    if (aggregate !== null && aggregate > 0 && requested > aggregate) keys.push('quantity_confirmation');
    if (!keys.length) keys.push('confirmation');
    const deadlines = [inventoryFresh ? observed + 300000 : null, ...chosen.map(rule => rule.expires)].filter(Number.isFinite);
    return { rules: chosen, keys: [...new Set(keys)], nextExpiry: deadlines.length ? Math.min(...deadlines) : null };
  }
  if (typeof module === 'object' && module.exports) module.exports = { evaluatePolicy, RULES, coloredTitaniumSelected, verifiedTaiwanSource, hasCompleteEstimate, merchantEstimateIsApplicable };
  if (!root.customElements || root.customElements.get('jdm-fulfillment-policy')) return;
  class FulfillmentPolicy extends root.HTMLElement {
    connectedCallback() {
      if (this.controller || this.dataset.themeId !== APPROVED_THEME || String(root.Shopify?.theme?.id) !== APPROVED_THEME || !['unpublished', 'main'].includes(root.Shopify?.theme?.role)) return;
      this.isIdoing = this.dataset.vendor === 'Idoing';
      this.scope = this.closest('product-info');
      this.output = this.querySelector('[data-jdm-policy-output]');
      this.sourceText = this.querySelector('[data-jdm-policy-payload]')?.textContent || '';
      this.stockText = this.scope?.querySelector('#JdmStockSnapshot-' + this.dataset.section + ' [data-jdm-stock-payload]')?.textContent || '';
      try { this.labels = JSON.parse(this.querySelector('[data-jdm-policy-labels]')?.textContent || '{}'); } catch { this.labels = {}; }
      if (!this.scope || !this.output) return;
      this.controller = new root.AbortController();
      this.unsubscribers = [];
      const on = (target, name, fn) => target?.addEventListener(name, fn, { signal: this.controller.signal });
      const bus = typeof subscribe === 'function' ? subscribe : null;
      const events = typeof PUB_SUB_EVENTS === 'object' ? PUB_SUB_EVENTS : null;
      if (bus && events?.optionValueSelectionChange && events?.variantChange) {
        this.unsubscribers.push(bus(events.optionValueSelectionChange, message => {
          if (this.scope.contains(message?.data?.event?.target)) this.invalidate();
        }));
        this.unsubscribers.push(bus(events.variantChange, message => this.acceptVariant(message?.data)));
      }
      on(this.scope, 'change', event => {
        if (event.target?.closest('variant-selects') || event.target?.matches('[name="id"]')) this.invalidate();
        else if (event.target?.matches('[name="quantity"]')) this.refresh();
      });
      on(this.scope, 'input', event => { if (event.target?.matches('[name="quantity"]')) this.refresh(); });
      on(root, 'pageshow', () => this.refresh());
      on(root.document, 'visibilitychange', () => { if (root.document.visibilityState === 'visible') this.refresh(); });
      this.refresh();
      // Omega renders after load; re-evaluate once its widget appears.
      if (root.MutationObserver) {
        const observer = new root.MutationObserver(() => { const seen = Array.from(this.scope.querySelectorAll('.ot-estimated-shipping')).some(node => /ships from idoing/i.test(node.textContent || '')); if (seen !== this.omegaSeen) { this.omegaSeen = seen; this.refresh(); } });
        observer.observe(this.scope, { childList: true, subtree: true });
        this.controller.signal.addEventListener('abort', () => observer.disconnect());
      }
    }
    selectedVariant() {
      const form = root.document.getElementById(this.dataset.form);
      return form && this.scope?.contains(form) ? String(form.querySelector('[name="id"]')?.value || '') : '';
    }
    requestedQuantity() {
      const input = this.scope.querySelector('[name="quantity"][form="' + this.dataset.form + '"]')
        || root.document.getElementById(this.dataset.form)?.querySelector('[name="quantity"]')
        || this.scope.querySelector('[name="quantity"]');
      return input ? Number(input.value) : 1;
    }
    invalidate() {
      this.sourceText = '';
      this.stockText = '';
      this.refresh();
    }
    acceptVariant(data) {
      if (!data || String(data.sectionId) !== String(this.scope?.sectionId || this.dataset.section)) return;
      if (!data.variant || String(data.variant.id) !== this.selectedVariant()) { this.invalidate(); return; }
      const source = data.html?.getElementById(this.id);
      this.sourceText = source?.querySelector('[data-jdm-policy-payload]')?.textContent || '';
      this.stockText = data.html?.getElementById('JdmStockSnapshot-' + this.dataset.section)?.querySelector('[data-jdm-stock-payload]')?.textContent || '';
      this.refresh();
    }
    hasRenderedMerchantEstimate(selected, now) {
      const inventory = root.document.getElementById('Inventory-' + this.dataset.section);
      if (!inventory || !this.scope?.contains(inventory) || inventory.closest('[hidden]') || root.getComputedStyle(inventory).display === 'none') return false;
      return Array.from(inventory.querySelectorAll('[data-jdm-merchant-eta-variant]')).some(node =>
        !node.closest('[hidden]') && root.getComputedStyle(node).display !== 'none'
        && node.textContent.trim() && merchantEstimateIsApplicable({
          variantId: node.dataset.jdmMerchantEtaVariant,
          date: node.dataset.jdmMerchantEtaDate,
          days: node.dataset.jdmMerchantEtaDays
        }, selected, now));
    }
    refresh() {
      root.clearTimeout(this.timer);
      if (!this.isConnected || !this.output) return;
      let payload = null, stockPayload = null;
      try { if (this.sourceText.length < 100000) payload = JSON.parse(this.sourceText); } catch {}
      try { if (this.stockText.length < 200000) stockPayload = JSON.parse(this.stockText); } catch {}
      const now = Date.now(), selected = this.selectedVariant();
      const stock = LIVE_STOCK_ENABLED ? root.JdmStockValidation?.evaluateSnapshot(stockPayload, selected, now) || {} : {};
      const result = evaluatePolicy(this.scope.pendingRequestUrl ? null : payload, selected, this.requestedQuantity(), now, stock);
      this.output.replaceChildren();
      const contact = this.querySelector('.jdm-policy-contact');
      let inlineContactRendered = false;
      // Generic origin/availability placeholders are not shipping estimates.
      // Keep the audited policy routing and stock gates unchanged.
      const hasMerchantEstimate = !this.scope.pendingRequestUrl && this.hasRenderedMerchantEstimate(selected, now);
      // Omega Estimated Delivery app already prints the iDoing shipping message; avoid showing it twice.
      const omegaIdoing = Array.from(this.scope.querySelectorAll('.ot-estimated-shipping')).some(node => !node.closest('[hidden]') && /ships from idoing/i.test(node.textContent || ''));
      // 2026-10-24 (Leo): the generic "Availability and lead time require confirmation" line never shows; jdm-delivery always prints a lead-time estimate
      // (variant_eta -> dropship_lead_time -> variant_lead_time -> product lead_time -> lead_time_days -> 2-month default).
      const visibleKeys = result.keys.filter(key => !['willow', 'distribution', 'confirmation', 'out_of_stock'].includes(key)
        && !(hasMerchantEstimate && ['out_of_stock', 'mfg', 'tomei', 'seibon', 'idoing'].includes(key))
        && !(omegaIdoing && key === 'idoing'));
      for (const key of visibleKeys) {
        const labelKey = key === 'mfg' && payload?.product?.vendor === 'PRL Motorsports' ? 'prl' : this.isIdoing && ['confirmation', 'out_of_stock', 'quantity_confirmation'].includes(key) ? 'idoing_' + key : key;
        const text = this.labels[labelKey];
        if (typeof text !== 'string' || !text) continue;
        const line = root.document.createElement('p');
        line.dataset.policyKey = key;
        line.style.whiteSpace = 'pre-line';
        const contactLink = key === 'idoing' ? root.document.createElement('a') : null;
        if (contactLink) contactLink.setAttribute('href', 'sms:+18285926055');
        if (contactLink && ['idoing_heading', 'idoing_details', 'idoing_confirm'].every(label => typeof this.labels[label] === 'string' && this.labels[label])) {
          const heading = root.document.createElement('strong');
          heading.textContent = this.labels.idoing_heading;
          contactLink.textContent = this.labels.idoing_confirm;
          line.append(heading, '\n' + this.labels.idoing_details + '\n', contactLink);
          inlineContactRendered = true;
        } else {
          line.textContent = text;
        }
        this.output.append(line);
      }
      if (contact) contact.hidden = !this.isIdoing || inlineContactRendered || !this.output.childElementCount || hasCompleteEstimate(result);
      this.hidden = !this.output.childElementCount && (!contact || contact.hidden);
      this.dataset.policyRules = result.rules.map(rule => rule.id).join(',');
      const membership = this.querySelector('[data-jdm-policy-membership]');
      if (membership) membership.hidden = !result.keys.includes('taiwan');
      if (Number.isFinite(result.nextExpiry)) this.timer = root.setTimeout(() => this.refresh(), Math.max(1, result.nextExpiry - Date.now()));
    }
    disconnectedCallback() {
      root.clearTimeout(this.timer);
      this.controller?.abort();
      this.unsubscribers?.forEach(fn => { if (typeof fn === 'function') fn(); });
      this.controller = null;
    }
  }
  root.customElements.define('jdm-fulfillment-policy', FulfillmentPolicy);
})(typeof globalThis === 'object' ? globalThis : this);

